import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { NAV } from "@/lib/testIds";
import { cn } from "@/lib/utils";

const links = [
  { to: "/", label: "Home", testId: NAV.home, end: true },
  { to: "/leasing", label: "Leasing", testId: NAV.leasing },
  { to: "/sales", label: "For Sale", testId: NAV.sales },
  { to: "/services", label: "Services", testId: NAV.services },
  { to: "/about", label: "About", testId: NAV.about },
  { to: "/contact", label: "Contact", testId: NAV.contact },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-20 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <Logo variant="primary" className="h-12 w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.testId}
                className={({ isActive }) =>
                  cn(
                    "text-sm font-medium tracking-wide transition-colors",
                    isActive
                      ? "text-primary"
                      : "text-muted-foreground hover:text-primary"
                  )
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Button
              asChild
              className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-5"
              data-testid={NAV.bookAppointment}
            >
              <Link to="/book-appointment">Book Appointment</Link>
            </Button>
          </div>

          <button
            className="lg:hidden p-2 -mr-2"
            aria-label="Toggle menu"
            data-testid={NAV.mobileMenuToggle}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testId}`}
                className={({ isActive }) =>
                  cn(
                    "py-3 px-3 rounded text-sm font-medium",
                    isActive
                      ? "bg-primary/5 text-primary"
                      : "text-foreground hover:bg-muted"
                  )
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book-appointment"
              onClick={() => setOpen(false)}
              className="mt-3 block bg-primary text-primary-foreground text-center py-3 rounded-sm font-semibold text-sm"
              data-testid="mobile-book-appointment-btn"
            >
              Book Appointment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
